import * as types from "./mutation-types";

export default {
  [types.SET_DATA](state, { prop, value }) {
    state[prop] = value;
  },

  [types.CLEAR_DATA](state) {
    state.orderName = "";
    state.orderDescription = "";
    state.orderState = "";
    state.editDisabled = false;
    state.isPublicOrder = false;
    state.symbol1 = "";
    state.symbol1FinVolume = 0;
    state.symbol1QtdVolume = 0;
    state.symbol2 = "";
    state.symbol2FinVolume = 0;
    state.symbol2QtdVolume = 0;
    state.operationType = "";
    state.method = "";
    state.startDate = "";
    state.endDate = "";
    state.volumeType = "FIN_VOLUME"; // 'FIN_VOLUME' ~~ 'QUANTITY'
    state.entryFactor = 0;
    state.currentFactor = 0;
    state.intercept = 0;
    state.slope = 0;
    state.residue = 0;
    state.advancedParams = false;
    state.TPFactor = 0;
    state.SLFactor = 0;
    state.symbol1MinVolume = 0;
    state.symbol1MaxVolume = 0;
    state.symbol2MinVolume = 0;
    state.symbol2MaxVolume = 0;
    state.tp_sl_calc_type = "factor";
    state.symbol1Price = 0;
    state.symbol2Price = 0;
  },

  [types.CLEAR_VOLUMES](state, type) {
    console.log("clear", type);
    switch (type) {
      case "QUANTITY":
        state.symbol1FinVolume = 0;
        state.symbol2FinVolume = 0;
        break;
      case "FIN_VOLUME":
        state.symbol1QtdVolume = 0;
        state.symbol2QtdVolume = 0;
        break;
    }
  },
};
